<template>
  <a :href="link" v-text="linkText" class="text-black"></a>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  props:{
    link:{
      type: String,
      default: '#'
    },
    linkText:{
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>